import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../../assets/css/recommendation-modal.css";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { Link, useParams } from "react-router-dom";
import SubscriberChart from "../common/dashboard9/subscribersChart";
import {
  fetchFakeSocialMedia,
  fetchFakeSocialMediaTotal,
  fetchFakeSocialMediaGraph,
  fetchSocailRemidiatedFalseTrue,
} from "../../actions/fakeMobileApp";
import moment from "moment";
import Pagination from "../Pagination/Pagination";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import TrialComponent from "../common/trialComponent";
import NoData from "../common/noDataComponetnt";
import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ReactSelect from "react-select";
import { Verified } from "@mui/icons-material";
import { API_URL } from "../../utils/constant";
import { toastr } from "react-redux-toastr";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { rescanSingle } from "../../actions/users";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import PieChart from "../../components/common/dashboard12/piechart.js";
import ImageModal from "../common/ImageModal";
import {
  takeDown,
  bulkTakeDown
} from "../../actions/look-alike";
import axios from "axios";
import $, { data } from "jquery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";
import { pageSize } from "firebase/firestore";
import { fetchCustomerDomains } from "../../actions/customer";


const SocialMediaProfile = () => {
  // const id = JSON.parse(localStorage.getItem("user")).organisationId;
  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });
  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.bs?.e;
  });
  const auth = useSelector((state) => state?.auth?.user);

  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );
  const myRef = useRef(null);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [isModal, setModal] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [search, setSearch] = useState("");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [category, setCategory] = useState("all");
  const [type, settype] = useState("all");
  const [platform, setPlatform] = useState([]);
  const [status, setStatus] = useState("all");
  const [domain, setDomain] = useState("");
  const [applyCriticality, setApplyCriticality] = useState([]);


  const [isTakeDownModal, setTakeDownModal] = useState("");
  const [isBulkTakeDownModal, setBulkTakeDownModal] = useState(false);
  const [bulkTakeDownComment, setBulkTakeDownComment] = useState("");
  const [stolenLocation, setStolenLocation] = useState("");
  const [contenSource, setContenSource] = useState("");
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');
  const [infringingIp, setInfringingIp] = useState("");
  const [editorContent, setEditorContent] = useState("");
  const [rowId, setRowId] = useState("");
  const [subject, setSubject] = useState("");
  const [userComment, setUserComment] = useState("");

  const state = useSelector(
    (state) => state?.fakeMobileApp?.fakeSocialMedia?.data
  );

  const totalCount = useSelector(
    (state) => state?.fakeMobileApp?.totalSocialCount?.data
  );

  const customerDomains = useSelector(
    (state) => state?.customer?.customerDomains?.data || []
  );

  const scanCompleted = useSelector(
    (state) => state?.fakeMobileApp?.scanCompleted
  );

  let objArray = {};
  // Check if state has the nested data structure
  const actualData = state?.data || state;
  for (let count = 0; count < actualData?.length; count++) {
    // Add null check for createdAt property
    const createdAtValue = actualData[count]?.createdAt;
    if (!createdAtValue) {
      continue; // Skip items without createdAt
    }
    let createdAt = createdAtValue.split("T")[0];
    if (objArray[createdAt]) {
      objArray[createdAt].push(actualData[count]);
    } else {
      objArray[createdAt] = [actualData[count]];
    }
  }

  const scanDetails = useSelector(
    (state) => state?.fakeMobileApp?.fakeGraphSocial?.data
  );

  const handleEditorChange = (even, editor) => {
    const data = editor.getData();
    setEditorContent(data); // Update the state with the new content
  };
  // Add these state variables to handle the date objects
  const [startDateObj, setStartDateObj] = useState(null);
  const [endDateObj, setEndDateObj] = useState(null);

  // Update startDateObj and endDateObj whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setStartDateObj(new Date(startDate));
    }
    if (endDate) {
      setEndDateObj(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Add useEffect to fetch customer domains
  useEffect(() => {
    // Fetch domains for the current client/organization
    if (id) {
      dispatch(fetchCustomerDomains(id));
    }
  }, [id, dispatch]);

  // Format platform array to comma-separated string for API
  const formatPlatformForAPI = (platformValue) => {
    if (!platformValue || (Array.isArray(platformValue) && platformValue.length === 0)) {
      return "all";
    }
    if (Array.isArray(platformValue)) {
      return platformValue.join(",");
    }
    return platformValue;
  };

  useEffect(() => {
    const platformParam = formatPlatformForAPI(platform);
    fetchFakeSocialMedia(id, dispatch, page, category, platformParam, status, startDate, endDate, pageSize, search, domain);
  }, [id, dispatch, page, category, platform, status, startDate, endDate, pageSize, search, domain]);

  useEffect(() => {
    fetchFakeSocialMediaGraph(id, dispatch);
  }, [id, dispatch]);

  useEffect(() => {
    fetchFakeSocialMediaTotal(id, dispatch);
  }, [id, dispatch]);

  useEffect(() => {
    // Handle both nested and flat data structures
    const totalProfiles = state?.totalProfiles || state?.data?.totalProfiles;
    setTotalItems(totalProfiles);
  }, [state?.totalProfiles, state?.data?.totalProfiles]);

  const addModal = () => {
    setModal("Form Wizard modal");
  };

  const submitTakeDownValue = async () => {
    if (userComment == "") {
      toastr.error("Error", "Comment cannot be empty.");
      return false;
    }

    try {
      setTakeDownModal(false);
      
      // Create FormData for file upload
      const formData = new FormData();
      formData.append('organisationId', id);
      formData.append('recordId', rowId);
      formData.append('userComment', userComment);
      formData.append('moduleName', 'social_media_profiles');
      
      // Add file if uploaded
      if (uploadedFile) {
        formData.append('file', uploadedFile);
      }

      // Call takeDown API with FormData
      const response = await takeDown(formData, dispatch);
      
      // Refresh the listing after successful takedown request
      if (response && !response.error) {
        const platformParam = formatPlatformForAPI(platform);
        fetchFakeSocialMedia(id, dispatch, page, category, platformParam, status, startDate, endDate, pageSize, search, domain);
      }
      
      // Reset the form fields
      setUserComment("");
      setUploadedFile(null);
      setFilePreview(null);
      // Clear file input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } catch (error) {
      console.error("Error submitting takedown request:", error);
    }
  };

  // Handle file change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check file size (10MB limit)
      if (file.size > 10 * 1024 * 1024) {
        toastr.error("Error", "File size must be less than 10MB");
        e.target.value = null;
        return;
      }
      
      setUploadedFile(file);
      
      // Create preview for images
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setFilePreview(reader.result);
        };
        reader.readAsDataURL(file);
      } else {
        setFilePreview(null);
      }
    }
  };

  // Submit bulk takedown request
  const submitBulkTakeDown = async () => {
    if (bulkTakeDownComment.trim() === "") {
      toastr.error("Error", "Comment cannot be empty.");
      return false;
    }

    if (selectedIds.length === 0) {
      toastr.error("Error", "Please select at least one record.");
      return false;
    }

    try {
      // Build entries array from selected IDs
      const entries = selectedIds.map((recordId) => ({
        recordId: recordId,
        moduleName: "social_media_profiles",
        userComment: bulkTakeDownComment,
      }));

      setBulkTakeDownModal(false);
      
      // Call bulk takedown API
      const response = await bulkTakeDown(id, entries, dispatch);
      
      // Refresh the listing after successful bulk takedown request
      if (response && !response.error) {
        const platformParam = formatPlatformForAPI(platform);
        fetchFakeSocialMedia(id, dispatch, page, category, platformParam, status, startDate, endDate, pageSize, search, domain);
        setSelectedIds([]);
        setMultiCheckTrue(false);
      }
      
      // Reset form
      setBulkTakeDownComment("");
    } catch (error) {
      console.error("Error submitting bulk takedown request:", error);
    }
  };

  const takeDownValue = (res) => {
    let ip;
    res?.dnsDetails?.map((row) => {
      return Object.keys(row || {}).map((key) => {
        let record = row[key];
        if (record && record.length == 0) return false;
        if (key !== "dns_a") return false;
        record?.map((val) => {
          ip = val;
        });
      });
    });
    let originalWebsite = client.website;
    let domainName = res.link;
    setStolenLocation(originalWebsite);
    setContenSource(domainName);
    setInfringingIp(ip);
    setRowId(res._id);
    setUserComment("");
    setUploadedFile(null);
    setFilePreview(null);
    // Clear file input
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    setTakeDownModal(true);
  };

  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  const snooze = (_id, event) => {
    if (event == "") {
    }

    if (event == "riskAccepted") {
    }

    if (event == "markAsFalsePositive") {
    }

    if (event == "markAsRemidiated") {
      let ids = [];
      ids.push(_id);
      const data = {
        action: "markAsRemidiated",
        fakeSocialMediaIds: selectedIds == 0 ? ids : selectedIds,
        actionNote: "",
        for: "forever",
      };
      const platformParam = formatPlatformForAPI(platform);
      fetchSocailRemidiatedFalseTrue(id, dispatch, data, 1, category, type, platformParam, status, startDate, endDate, search, pageSize, domain);
      setSelectedValue("pleaseSelect");
      setActionNote("");
      setSelectedIds([]);
    }
  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: "resetAction",
      fakeSocialMediaIds: selectedIds == 0 ? ids : selectedIds,
    };
    const platformParam = formatPlatformForAPI(platform);
    fetchSocailRemidiatedFalseTrue(id, dispatch, data, 1, category, type, platformParam, status, startDate, endDate, search, pageSize, domain);
    setSelectedIds([]);
  };

  const submit = () => {
    const data = {
      action: action,
      fakeSocialMediaIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    const platformParam = formatPlatformForAPI(platform);
    fetchSocailRemidiatedFalseTrue(id, dispatch, data, 1, category, type, platformParam, status, startDate, endDate, search, pageSize, domain);
    setModal("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };

  let mapData = state;
  // Handle both nested and flat data structures
  mapData = state?.data ? state?.data : state;
  let currentTableData = [];
  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }

  if (applyCriticality?.length) {
    currentTableData = currentTableData.filter(item => {
      const severityValue = (item?.criticality || item?.severity || item?.highestSeverity || item?.overallSeverity || "").toString();
      return applyCriticality.includes(severityValue);
    });
  }

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/getFakeSocialMediav2/${id}/excel`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}Social Media Page.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const reScan = () => {
    let data = {
      "moduleName": ["socailMediaProfile"]
    }
    rescanSingle(id, data)
  }

  const updateSuspiciousStatus = async (isSuspicious) => {
    if (selectedIds.length === 0) {
      toastr.error("Error", "Please select at least one profile.");
      return;
    }

    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

      const response = await axios.put(
        `${API_URL}/getFakeSocialMediav2/${id}/update-suspicious-status`,
        {
          _ids: selectedIds,
          isSuspicious: isSuspicious
        }
      );

      if (response.data) {
        toastr.success("Success", `Profiles marked as ${isSuspicious ? 'verified' : 'unverified'} successfully.`);
        // Refresh the data
        const platformParam = formatPlatformForAPI(platform);
        fetchFakeSocialMedia(id, dispatch, page, category, platformParam, status, startDate, endDate, pageSize, search, domain);
        // Clear selections
        setSelectedIds([]);
        setMultiCheckTrue(false);
      }
    } catch (error) {
      toastr.error("Error", "Failed to update suspicious status.");
      console.error("Error updating suspicious status:", error);
    }
  };

  const series = [
    totalCount?.totalFacebookProfiles,
    totalCount?.totalLiknedInProfiles,
    totalCount?.totalTwitterProfiles,
    totalCount?.totalInstagramProfiles,
    totalCount?.totalTelegramProfiles,
    totalCount?.totalYoutubeProfiles,
    totalCount?.totalTiktokProfiles
  ];

  const labels = ["Facebook", "LinkedIn", "Twitter", "Instagram", "Telegram", "Youtube", "Tiktok"];
  const colour = ['#1877F2', '#0077B5', '#1DA1F2', '#E4405F', '#0088CC', '#FF0000', '#000000'];
  const platformOptions = [
    { value: "", label: "All platforms" },
    { value: "facebook", label: "Facebook" },
    { value: "linkedin", label: "LinkedIn" },
    { value: "twitter", label: "Twitter" },
    { value: "instagram", label: "Instagram" },
    { value: "telegram", label: "Telegram" },
    { value: "youtube", label: "YouTube" },
    { value: "tiktok", label: "TikTok" }
  ];
  // Add these new state variables
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);

  // Update tempStartDate and tempEndDate whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setTempStartDate(new Date(startDate));
    }
    if (endDate) {
      setTempEndDate(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Add this new function to format the displayed date range
  const formatDateRange = () => {
    if (startDate && endDate) {
      return `Selected date: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''} to ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    } else if (startDate) {
      return `From: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''}`;
    } else if (endDate) {
      return `Till: ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    }
    return "Select date range"; // Default placeholder text
  };

  // Add this function to handle applying the selected date range
  const applyDateRange = () => {
    if (tempStartDate) {
      setStartDate(format(tempStartDate, 'yyyy-MM-dd'));
    } else {
      setStartDate('');
    }

    if (tempEndDate) {
      setEndDate(format(tempEndDate, 'yyyy-MM-dd'));
    } else {
      setEndDate('');
    }

    setDatePickerOpen(false);
    setPage(1);
  };

  // Update the cancelDateSelection function to clear all dates
  const cancelDateSelection = () => {
    // Clear all date states when cancel is clicked
    setTempStartDate(null);
    setTempEndDate(null);
    setStartDate('');
    setEndDate('');
    setStartDateObj(null);
    setEndDateObj(null);
    setDatePickerOpen(false);
  };

  const [isRedirectModalOpen, setIsRedirectModalOpen] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [isTicketDetailsModal, setIsTicketDetailsModal] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const fileInputRef = useRef(null);
  const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);
  const [previewImageUrl, setPreviewImageUrl] = useState("");

  const handleExternalLinkClick = (e, url) => {
    e.preventDefault();
    setRedirectUrl(url);
    setIsRedirectModalOpen(true);
  };

  const handleScreenshotPreview = (url) => {
    if (!url) return;
    setPreviewImageUrl(url);
    setIsImagePreviewOpen(true);
  };

  const handleRedirect = () => {
    window.open(redirectUrl, '_blank');
    setIsRedirectModalOpen(false);
    setRedirectUrl("");
  };

  // Function to handle viewing ticket details
  const handleViewTicketDetails = (profile) => {
    setSelectedTicket(profile);
    setIsTicketDetailsModal(true);
  };

  return (
    <>
      <div className="container-fluid">
        <AccessPage></AccessPage>
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h1 className="welcome-text">Social Media Profiles</h1>
              <nav aria-label="breadcrumb" className="mt-1">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    {vendorId ? <>
                      <Link to="/vendor"
                        onClick={(() => {
                          sessionStorage.clear();
                        })}
                      >Vendor Assessment</Link>
                    </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                  </li>
                  {
                    vendorName ?
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                        style={{ color: "white" }}
                      >
                        <Link to={`/dashboard/vendor/${vendorId}`}
                        >{vendorName}</Link>
                      </li> : ''
                  }
                  <li
                    className="breadcrumb-item active"
                    aria-current="page"
                    style={{ color: "white" }}
                  >
                    Social Media Profile
                  </li>
                </ol>
              </nav>
            </div>
            <div className="col-md-6 col-sm-12 text-right hidden-xs d-flex justify-content-end">
              <span>
							<a
								onClick={(e) => {
									e.preventDefault();
									setIsRecommendationModal(true);
								}}
								href="#"
								className="btn btn-sm btn-primary mr-1"
                style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
							>
                <i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
								Recommendation
							</a>
						</span>
              {auth?.accessLevel == "Admin" && (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    reScan();
                  }}
                  style={{ color: "black", fontWeight: "bold" }}
                  className="btn btn-primary mr-1"
                >
                  Rescan
                </a>
              )}
              {mapData?.length === 0 ? null : (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    downloadFile();
                  }}
                  href="/add-report"
                  className="btn btn-sm btn-primary mr-1 download-report"
                >
                  Download Details
                </a>
              )}
            </div>
          </div>
        </div>

        {typeof scanCompleted !== "undefined" && !scanCompleted && (
          <div className="card border-success">
            <ScanMessage />
          </div>
        )}

        {/* <div className="row clearfix">
          <div className="col-lg-3 col-md-6">
            <div className="card">
              <div className="body">
                <div className="d-flex align-items-center">
                  <div className="icon-in-bg bg-indigo text-white rounded-circle">
                    <i className="fa fa-briefcase"></i>
                  </div>
                  <div className="ml-4">
                    <span>Total Profiles</span>
                    <h4 className="mb-0 font-weight-medium">12</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="card">
              <div className="body">
                <div className="d-flex align-items-center">
                  <div className="icon-in-bg bg-azura text-white rounded-circle">
                    <i className="fa fa-credit-card"></i>
                  </div>
                  <div className="ml-4">
                    <span>Detected as Issues</span>
                    <h4 className="mb-0 font-weight-medium">12</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="card">
              <div className="body">
                <div className="d-flex align-items-center">
                  <div className="icon-in-bg bg-orange text-white rounded-circle">
                    <i className="fa fa-users"></i>
                  </div>
                  <div className="ml-4">
                    <span>Change in last 30 days</span>
                    <h4 className="mb-0 font-weight-medium">$25,805</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="card">
              <div className="body">
                <div className="d-flex align-items-center">
                  <div className="icon-in-bg bg-pink text-white rounded-circle">
                    <i className="fa fa-life-ring"></i>
                  </div>
                  <div className="ml-4">
                    <span>Change in last 90 days</span>
                    <h4 className="mb-0 font-weight-medium">$13,651</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="row clearfix">
          <div
            className="col-lg-5 col-md-12 col-sm-12"
            style={{ minHeight: "480px" }}
          >
            <div className="card">
              <div className="body" style={{ minHeight: "480px" }}>
                <h6 className="mb-3 welcome-textSmall">Records Found</h6>
                <div className="d-flex mb-3 justify-content-center">
                  {series && series?.length > 0 && <PieChart series={series} label={labels} colour={colour} />}
                </div>
                <div>
                  <label
                    className="d-block"
                    style={{ cursor: "pointer" }}
                  // onClick={() => setfilterData("active")}
                  >
                    <span className="darkblueShadow" style={{ backgroundColor: '#1877F2' }}></span>
                    Fake Facebook Profiles
                    <span className="float-right">
                      {totalCount?.totalFacebookProfiles || 0}
                    </span>
                  </label>
                </div>
                <div>
                  <label
                    className="d-block"
                    style={{ cursor: "pointer" }}
                  // onClick={() => setfilterData("60days")}
                  >
                    <span className="darkBlueShadow redShadow" style={{ backgroundColor: '#0077B5' }}></span>
                    Fake LinkedIn Profiles
                    <span className="float-right">
                      {totalCount?.totalLiknedInProfiles || 0}
                    </span>
                  </label>
                </div>
                <div>
                  <label
                    className="d-block"
                    style={{ cursor: "pointer" }}
                  // onClick={() => setfilterData("60days")}
                  >
                    <span className="yellowShadow" style={{ backgroundColor: '#1DA1F2' }}></span>
                    Fake Twitter Profiles
                    <span className="float-right">
                      {totalCount?.totalTwitterProfiles || 0}
                    </span>
                  </label>
                </div>
                <div>
                  <label
                    className="d-block"
                    style={{ cursor: "pointer" }}
                  // onClick={() => setfilterData("30days")}
                  >
                    <span className="greenShadow" style={{ backgroundColor: '#E4405F' }}></span>
                    Fake Instagram Profiles
                    <span className="float-right">
                      {totalCount?.totalInstagramProfiles || 0}
                    </span>
                  </label>
                </div>
                <div>
                  <label
                    className="d-block"
                    style={{ cursor: "pointer" }}
                  // onClick={() => setfilterData("30days")}
                  >
                    <span className="redShadow" style={{ backgroundColor: '#0088CC' }}></span>
                    Fake Telegram Profiles
                    <span className="float-right">
                      {totalCount?.totalTelegramProfiles || 0}
                    </span>
                  </label>
                </div>
                <div>
                  <label
                    className="d-block"
                    style={{ cursor: "pointer" }}
                  // onClick={() => setfilterData("30days")}
                  >
                    <span className="greenShadow" style={{ backgroundColor: '#FF0000' }}></span>
                    Fake Youtube Profiles
                    <span className="float-right">
                      {totalCount?.totalYoutubeProfiles || 0}
                    </span>
                  </label>
                </div>
                <div>
                  <label
                    className="d-block"
                    style={{ cursor: "pointer" }}
                  // onClick={() => setfilterData("30days")}
                  >
                    <span className="greenShadow" style={{ backgroundColor: '#000000' }}></span>
                    Fake Tiktok Profiles
                    <span className="float-right">
                      {totalCount?.totalTiktokProfiles || 0}
                    </span>
                  </label>
                </div>

                {client?.subscriptionType == "trial" && (
                  <div className="card border-warning">
                    <TrialComponent />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-12 col-sm-12">
            <div className="card">
              <div className="body" style={{ minHeight: "480px" }}>
                <h6 className="welcome-textSmall">Previous scan details</h6>
                {scanDetails && (
                  <SubscriberChart
                    dates={scanDetails?.dates}
                    data={scanDetails?.scanDetails}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
          <li className="nav-item">
            <a
              className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("all");
                settype("all");
                setPage(1);
                setStatus("all");
                setPlatform([]);
                setSelectedIds([]);
                setSearch("");
                setDomain("");
              }}
            >
              Current
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("risk-accepted");
                settype("all");
                setPage(1);
                setStatus("all");
                setPlatform([]);
                setSelectedIds([]);
                setSearch("");
                setDomain("");
              }}
            >
              Risk Accepted
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("false-positive");
                settype("all");
                setPage(1);
                setStatus("all");
                setPlatform([]);
                setSelectedIds([]);
                setSearch("");
                setDomain("");
              }}
            >
              False Positive
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("remidiated");
                settype("all");
                setPage(1);
                setStatus("all");
                setPlatform([]);
                setSelectedIds([]);
                setSearch("");
                setDomain("");
              }}
            >
              Remediated
            </a>
          </li>
        </ul>
        <div className="card card_tableBox">
          <div className="body">
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="row clearfix mb-2">
                  <div className="col-lg-3 col-md-12 ReactSelect__Wrapper">
                    <ReactSelect
                      isClearable
                      isMulti
                      placeholder="Social media platform"
                      value={platformOptions.filter(opt => Array.isArray(platform) && platform.includes(opt.value))}
                      onChange={(selectedOptions) => {
                        const values = (selectedOptions || []).map(opt => opt.value).filter(Boolean);
                        setPlatform(values);
                        setPage(1);
                      }}
                      options={platformOptions}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      style={{ width: '100%' }}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '4px',
                          width: '100%',
                        })
                      }}
                    />
                  </div>
                  <div className="col-lg-3 col-md-12">
                    <select
                      className="custom-select custom-select-sm form-control form-control-sm"
                      value={status}
                      onChange={(e) => { setStatus(e.target.value); setPage(1); }}
                    >
                      <option value="all">All</option>
                      <option value="verified">Verified</option>
                      <option value="unverified">Unverified</option>
                      <option value="linkdown">Takedown</option>
                    </select>
                  </div>
                  <div className="col-lg-3 col-md-12">
                    <div className="search-input-container" style={{ position: "relative", width: "100%" }}>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Search profiles..."
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                          setPage(1);
                        }}
                      />
                      <span className="search-icon" style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", color: "#495057" }}>
                        <i className="fa fa-search" aria-hidden="true"></i>
                      </span>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-12">
                    <div className="date-picker-container">
                      <div className="date-range-input">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Select date range"
                          value={formatDateRange()}
                          onClick={() => setDatePickerOpen(true)}
                          readOnly
                        />
                        <span className="calendar-icon">
                          <i className="fa fa-calendar" aria-hidden="true"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row clearfix">
                  <div className="col-md-12 mb-2 d-flex align-items-center">
                    {selectedIds.length > 1 && userPermission && category === "all" && (
                      <Box sx={{ width: 160 }}>
                        <FormControl fullWidth>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedValue}
                            onChange={(event) => {
                              setAction(event.target.value);
                              snooze("", event.target.value);
                            }}
                          >
                            <MenuItem value="pleaseSelect">
                              Snooze Options
                            </MenuItem>
                            <MenuItem
                              value="riskAccepted"
                              onClick={() => {
                                addModal();
                              }}
                            >
                              Risk Accepted
                            </MenuItem>
                            <MenuItem
                              value="markAsFalsePositive"
                              onClick={() => {
                                addModal();
                              }}
                            >
                              False Positive
                            </MenuItem>
                            <MenuItem value="markAsRemidiated">
                              Remediated
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    )}
                    {selectedIds.length > 1 && userPermission &&
                      (category == "false-positive" ||
                        category == "risk-accepted") && (
                        <button
                          className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                          onClick={() => Unsnoozed("")}
                        >
                          Unsnooze
                        </button>
                      )}
                    {selectedIds.length > 1 && userPermission && category === "all" && (
                      <button
                        className="btn btn-danger btn-sm ml-2"
                        onClick={() => setBulkTakeDownModal(true)}
                        title="Request takedown for selected profiles"
                      >
                        <i className="fa fa-arrow-down mr-1"></i>
                        Bulk Takedown Request
                      </button>
                    )}
                    {selectedIds.length > 0 && userPermission && category === "all" && auth?.accessLevel === "super-admin" && (
                      <div className="d-flex">
                        <button
                          className="btn btn-success btn-sm ml-2"
                          onClick={() => updateSuspiciousStatus(true)}
                          title="Mark selected profiles as verified"
                        >
                          <i className="fa fa-check mr-1"></i>
                          Mark as Verified
                        </button>
                        <button
                          className="btn btn-warning btn-sm ml-2"
                          onClick={() => updateSuspiciousStatus(false)}
                          title="Mark selected profiles as unverified"
                        >
                          <i className="fa fa-times mr-1"></i>
                          Mark as Unverified
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <div className="table-responsive" ref={myRef}>
                  <table className="table table-custom spacing5 mb-0">
                    <thead>
                      <tr>
                        {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                          category === "risk-accepted" ||
                          category === "false-positive") && (
                            <th>
                              <input
                                type="checkbox"
                                checked={
                                  selectedIds == 0 ? false : multiCheckTrue
                                }
                                onClick={() => {
                                  multicheck(currentTableData);
                                }}
                                className="checkUncheck"
                              />
                            </th>
                          )}
                        {/* <th>#No</th> */}
                        <th>Status</th>
                        <th>Platform</th>
                        <th>Page URL</th>
                        {/* <th>Profile Picture</th> */}
                        <th>Screenshot</th>
                        <th>Take Down Status</th>
                        {category !== "all" && <th>Action Note</th>}
                        <th>Last Updated at</th>
                        {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "all" ||
                          category === "risk-accepted" ||
                          category === "false-positive") && (
                            <th style={{ width: "80" }}>Action</th>
                          )}
                      </tr>
                    </thead>
                    <tbody>
                      {client?.subscriptionType == "trial" ? (
                        <tr>
                          <td colSpan={7}>
                            <NoData />
                          </td>
                        </tr>
                      ) : (
                        currentTableData?.map((res, index) => {
                          let source = res?.source || res?.socialMediaPlatform || "NA";
                          return (
                            <tr key={index}>
                              {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                                category === "risk-accepted" ||
                                category === "false-positive") && (
                                  <td>
                                    <input
                                      onClick={() => singleClick(res?._id)}
                                      checked={selectedIds?.includes(res?._id)}
                                      type="checkbox"
                                      className="checkUncheck"
                                    />
                                  </td>
                                )}
                              {/* <td>
                                <span>{(page - 1) * 10 + 1 + index}</span>
                              </td> */}
                              <td>
                                {" "}
                                <span
                                  className={
                                    res?.isSuspicious
                                      ? "badge-success"
                                      : "badge-danger"
                                  }
                                >
                                  {res?.isSuspicious
                                    ? "Verified Threat"
                                    : "Unverified Threat"}
                                </span>
                                {res?.isLinkDown && (
                                  <span className="badge-warning">
                                    Take down
                                  </span>
                                )}
                              </td>
                              <td>
                                {source.charAt(0).toUpperCase() +
                                  source.slice(1)}
                              </td>
                              <td style={{ whiteSpace: "unset" }}>
                                <a
                                  href={`${res?.link || res?.fakePageUrl}`}
                                  onClick={(e) => handleExternalLinkClick(e, res?.link || res?.fakePageUrl)}
                                  style={{ color: "white" }}
                                >
                                  {res?.link || res?.fakePageUrl}
                                </a>
                              </td>
                              {/* <td style={{ width: "140px", textAlign: "center" }}>
                                {res?.profile_pic_url ? (
                                  <div>
                                    <img
                                      src={res.profile_pic_url}
                                      alt="Profile Picture"
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                        border: "2px solid #e9ecef"
                                      }}
                                      onClick={() => window.open(res.profile_pic_url, '_blank')}
                                      onError={(e) => {
                                        e.target.style.display = 'none';
                                        e.target.nextSibling.style.display = 'block';
                                      }}
                                    />
                                    <div style={{ display: 'none', padding: '15px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                                      Image not available
                                    </div>
                                  </div>
                                ) : (
                                  <div style={{ padding: '15px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                                    No image available
                                  </div>
                                )}
                              </td> */}
                              <td style={{ width: "140px", textAlign: "center" }}>
                                {res?.screenshot_url ? (
                                  <div>
                                    <img
                                      src={res.screenshot_url}
                                      alt="Screenshot"
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                        border: "2px solid #e9ecef"
                                      }}
                                      onClick={() => handleScreenshotPreview(res.screenshot_url)}
                                      onError={(e) => {
                                        e.target.style.display = 'none';
                                        e.target.nextSibling.style.display = 'block';
                                      }}
                                    />
                                    <div style={{ display: 'none', padding: '15px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                                      Image not available
                                    </div>
                                  </div>
                                ) : (
                                  <div style={{ padding: '15px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                                    No image available
                                  </div>
                                )}
                              </td>
                              <td>
                                {res?.ticketExists ? (
                                  <div>
                                    <span className={`badge badge-${res?.ticketStatus === 'completed' ? 'success' : res?.ticketStatus === 'inProgress' ? 'warning' : 'info'}`}>
                                      {res?.ticketStatus === 'completed' ? 'Completed' :
                                        res?.ticketStatus === 'inProgress' ? 'In Progress' :
                                          res?.ticketStatus || 'Submitted'}
                                    </span>
                                    <div className="mt-1">
                                      <button
                                        className="btn btn-sm btn-outline-info"
                                        onClick={() => handleViewTicketDetails(res)}
                                        title="View Ticket Details"
                                      >
                                        <i className="fa fa-ticket mr-1"></i>
                                        Ticket Details
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="takeDownBtnContainer">
                                    <Link
                                      to="#"
                                      className="takeDownBtn"
                                      onClick={() => takeDownValue(res)}
                                    >
                                      Request Takedown <i className="fa fa-arrow-down ml-2"></i>
                                    </Link>
                                  </div>
                                )}
                              </td>
                              {category !== "all" && <td style={{ whiteSpace: "unset" }}>{res?.actionNote ? res.actionNote : "N/A"}</td>}
                              <td>
                                {res?.updatedAt
                                  ? moment(res?.updatedAt).format(
                                    "DD-MM-YYYY"
                                  )
                                  : res?.createdAt
                                    ? moment(res?.createdAt).format(
                                      "DD-MM-YYYY"
                                    )
                                    : "NA"}
                              </td>
                              {auth?.accessLevel != "Threat Analyst" && userPermission && category === "all" && (
                                <td>
                                  <div className="d-flex flex-column gap-2">
                                    <Box sx={{ width: 160 }}>
                                      <FormControl fullWidth>
                                        <Select
                                          labelId="demo-simple-select-label"
                                          id="demo-simple-select"
                                          value={selectedValue}
                                          onChange={(event) => {
                                            setAction(event.target.value);
                                            snooze(res?._id, event.target.value);
                                          }}
                                        >
                                          <MenuItem value="pleaseSelect">
                                            Snooze Options
                                          </MenuItem>
                                          <MenuItem
                                            value="riskAccepted"
                                            onClick={() => {
                                              addModal();
                                              setLookalikeAppId([res._id]);
                                            }}
                                          >
                                            Risk Accepted
                                          </MenuItem>
                                          <MenuItem
                                            value="markAsFalsePositive"
                                            onClick={() => {
                                              addModal();
                                              setLookalikeAppId([res._id]);
                                            }}
                                          >
                                            False Positive
                                          </MenuItem>
                                          <MenuItem value="markAsRemidiated">
                                            Remediated
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Box>
                                  </div>
                                </td>
                              )}
                              {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "risk-accepted" ||
                                category === "false-positive") && (
                                  <td>
                                    <button
                                      className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                      onClick={() => Unsnoozed(res?._id)}
                                    >
                                      Unsnooze
                                    </button>
                                  </td>
                                )}
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-between align-content-center mt-3">
                  <div className="dataTables_paginate">
                    {totalItems > 0 && (
                      <Pagination
                        className="pagination-bar"
                        currentPage={page}
                        totalCount={totalItems}
                        pageSize={pageSize}
                        onPageChange={(page) => setPage(page)}
                      />
                    )}
                  </div>
                  {totalItems > 10 && (
                    <select
                      value={pageSize}
                      onChange={(e) => {
                        setPageSize(parseInt(e.target.value))
                      }}
                      className="form-control limitSelectBox"
                    >
                      <option value={10}>10 per page</option>
                      <option value={25}>25 per page</option>
                      <option value={50}>50 per page</option>
                      <option value={100}>100 per page</option>
                    </select>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {action == "markAsFalsePositive"
                    ? "Mark As False Positive"
                    : "Risk Accepted"}
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModal("");
                    setActionNote("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-md-12">
                        <label className="col-lg-6 col-md-12">Snooze for</label>
                        <div className="form-group ol-lg-12 col-md-12">
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm"
                            onChange={(e) => setForValue(e.target.value)}
                          >
                            <option value="forever">Forever</option>
                            <option value="3 months">3 Months</option>
                            <option value="6 months">6 Months</option>
                            <option value="12 months">12 Months</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <label className="col-lg-12 col-md-12">Detail</label>
                        <div className="form-group col-lg-12 col-md-12">
                          <textarea
                            onChange={(e) => setActionNote(e.target.value)}
                            className="form-control"
                            value={actionNote}
                            rows="3"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-lg-12 col-md-12"
                        style={{ marginRight: "28px" }}
                      >
                        <button
                          type="button"
                          style={{ color: "black", fontWeight: "bold" }}
                          onClick={submit}
                          className="btn btn-round btn-primary mr-1 pull-right"
                        >
                          Submit
                        </button>
                        &nbsp;&nbsp;
                        <button
                          type="button"
                          onClick={() => {
                            setModal("");
                            setActionNote("");
                          }}
                          className="btn btn-round btn-default pull-right"
                          style={{ marginRight: "10px" }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>   {datePickerOpen && (
          <div className="date-range-overlay" onClick={() => setDatePickerOpen(false)}>
            <div className="date-range-picker-popup" onClick={(e) => e.stopPropagation()}>
              <div className="date-range-picker-header">
                {tempStartDate && tempEndDate
                  ? `Selected date: ${format(tempStartDate, 'MM/dd/yyyy')} to ${format(tempEndDate, 'MM/dd/yyyy')}`
                  : "Select date range"}
              </div>
              <div className="date-range-calendars">
                <div>
                  <h6>From</h6>
                  <DatePicker
                    selected={tempStartDate}
                    onChange={(date) => {
                      setTempStartDate(date);
                      if (tempEndDate && date > tempEndDate) {
                        setTempEndDate(null);
                      }
                    }}
                    selectsStart
                    startDate={tempStartDate}
                    endDate={tempEndDate}
                    inline
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
                <div>
                  <h6>To</h6>
                  <DatePicker
                    selected={tempEndDate}
                    onChange={(date) => setTempEndDate(date)}
                    selectsEnd
                    startDate={tempStartDate}
                    endDate={tempEndDate}
                    minDate={tempStartDate}
                    inline
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
              </div>
              <div className="date-range-actions">
                <button
                  className="date-range-apply"
                  onClick={applyDateRange}
                >
                  Apply Filter
                </button>
                <button
                  className="date-range-cancel"
                  onClick={cancelDateSelection}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
        <div
          className={`modal fade Form-Wizard-modal ${isTakeDownModal ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Social Media Profile Takedown Request
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setTakeDownModal(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row clearfix">
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="card card_ck">
                      <div className="body">
                        <div className="col-md-12">
                          <label className="col-lg-12 col-md-12">Comment <span className="text-danger">*</span></label>
                          <div className="form-group col-lg-12 col-md-12">
                            <textarea
                              onChange={(e) => setUserComment(e.target.value)}
                              value={userComment}
                              className="form-control"
                              rows="3"
                              required
                            ></textarea>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <label className="col-lg-12 col-md-12">Upload File (Optional)</label>
                          <div className="form-group col-lg-12 col-md-12">
                            <input
                              ref={fileInputRef}
                              type="file"
                              className="form-control"
                              onChange={handleFileChange}
                              accept="image/*,.pdf,.doc,.docx"
                            />
                            <small className="form-text text-muted">
                              Accepted formats: Images, PDF, DOC, DOCX (Max 10MB)
                            </small>
                          </div>
                          {filePreview && (
                            <div className="form-group col-lg-12 col-md-12">
                              <img 
                                src={filePreview} 
                                alt="Preview" 
                                style={{ maxWidth: '100%', maxHeight: '200px', marginTop: '10px' }}
                              />
                            </div>
                          )}
                          {uploadedFile && !filePreview && (
                            <div className="form-group col-lg-12 col-md-12">
                              <div className="alert alert-info">
                                <i className="fa fa-file"></i> {uploadedFile.name} ({(uploadedFile.size / 1024 / 1024).toFixed(2)} MB)
                              </div>
                            </div>
                          )}
                          {uploadedFile && (
                            <div className="form-group col-lg-12 col-md-12">
                              <button
                                type="button"
                                className="btn btn-sm btn-danger"
                                onClick={() => {
                                  setUploadedFile(null);
                                  setFilePreview(null);
                                  // Clear file input
                                  if (fileInputRef.current) {
                                    fileInputRef.current.value = '';
                                  }
                                }}
                              >
                                <i className="fa fa-trash"></i> Remove File
                              </button>
                            </div>
                          )}
                        </div>
                        <div className="col-lg-12 col-md-12">
                          <button
                            className="btn btn-default btn-sm mr-1 pull-right"
                            style={{ marginTop: "10px" }}
                            onClick={() => {
                              setTakeDownModal(false);
                              setUserComment("");
                              setUploadedFile(null);
                              setFilePreview(null);
                              // Clear file input
                              if (fileInputRef.current) {
                                fileInputRef.current.value = '';
                              }
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            className="btn btn-primary btn-sm mr-1 pull-right"
                            style={{ marginTop: "10px" }}
                            onClick={() => submitTakeDownValue()}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`modal fade Form-Wizard-modal ${isBulkTakeDownModal ? "d-block show" : ""}`}>
          <div className="modal-dialog modal-lg" id="bulkTakedownModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="bulkTakedownModalLabel">
                  Bulk Takedown Request 
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setBulkTakeDownModal(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row clearfix">
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="card card_ck">
                      <div className="body">
                        <div className="col-md-12">
                          <label className="col-lg-12 col-md-12">Comment <span className="text-danger">*</span></label>
                          <div className="form-group col-lg-12 col-md-12">
                            <textarea
                              onChange={(e) => setBulkTakeDownComment(e.target.value)}
                              value={bulkTakeDownComment}
                              className="form-control"
                              rows="3"
                              placeholder="Enter comment for all selected items..."
                              required
                            ></textarea>
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 takeDownButtonBox">
                          <button
                            className="btn btn-default btn-sm mr-1 pull-right"
                            style={{ marginTop: "10px" }}
                            onClick={() => {
                              setBulkTakeDownModal(false);
                              setBulkTakeDownComment("");
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            className="btn btn-primary btn-sm mr-1 pull-right"
                            style={{ marginTop: "10px" }}
                            onClick={() => submitBulkTakeDown()}
                          >
                            Submit Bulk Takedown
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`modal fade Form-Wizard-modal ${isRedirectModalOpen ? "d-block show" : ""}`}>
          <div className="modal-dialog" id="urlWarningModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">External Link Warning</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setIsRedirectModalOpen(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="alert alert-warning mb-3">
                  <i className="fa fa-exclamation-triangle mr-2"></i>
                  You are about to leave this site and visit an external URL. This link may lead to a third-party website. Please proceed with caution.
                </div>
                <p className="mb-0">URL: <strong>{redirectUrl}</strong></p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={() => setIsRedirectModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleRedirect}
                >
                  Proceed Anyway
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ImageModal
        isOpen={isImagePreviewOpen}
        onClose={() => {
          setIsImagePreviewOpen(false);
          setPreviewImageUrl("");
        }}
        imageSrc={previewImageUrl}
      />

      {/* Ticket Details Modal */}
      <div className={`modal fade Form-Wizard-modal ${isTicketDetailsModal ? "d-block show" : ""}`}>
        <div className="modal-dialog modal-md" id="ticketDetailsModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Ticket Details</h5>
              <button
                type="button"
                className="close"
                onClick={() => setIsTicketDetailsModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              {selectedTicket && (
                <div className="row clearfix">
                  <div className="col-12">
                    <div className="card mb-3">
                      <div className="card-header">
                        <h6 className="mb-0">Ticket Information</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-6">
                            <p><strong>Ticket ID:</strong></p>
                            <p className="text-muted font-monospace">{selectedTicket._id}</p>
                          </div>
                          <div className="col-md-6">
                            <p><strong>Status:</strong></p>
                            <span className={`badge badge-${selectedTicket?.ticketStatus === 'completed' ? 'success' : selectedTicket?.ticketStatus === 'inProgress' ? 'warning' : 'info'}`}>
                              {selectedTicket?.ticketStatus === 'completed' ? 'Completed' :
                                selectedTicket?.ticketStatus === 'inProgress' ? 'In Progress' :
                                  selectedTicket?.ticketStatus || 'Submitted'}
                            </span>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-6">
                            <p><strong>Created:</strong></p>
                            <p>{new Date(selectedTicket.createdAt).toLocaleDateString()}</p>
                          </div>
                          {selectedTicket?.updatedAt && selectedTicket.updatedAt !== selectedTicket.createdAt && (
                            <div className="col-md-6">
                              <p><strong>Last Updated:</strong></p>
                              <p>{new Date(selectedTicket.updatedAt).toLocaleDateString()}</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header">
                        <h6 className="mb-0">Request Details</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-6">
                            <h6>User Comment:</h6>
                            {selectedTicket?.userComment ? (
                              <div className="alert alert-info">
                                {selectedTicket.userComment}
                              </div>
                            ) : (
                              <div className="alert alert-light">
                                No comment provided
                              </div>
                            )}
                          </div>
                          <div className="col-md-6">
                            <h6>Admin Comment:</h6>
                            {selectedTicket?.actionNote ? (
                              <div className="alert alert-warning">
                                {selectedTicket.actionNote}
                              </div>
                            ) : (
                              <div className="alert alert-light">
                                No admin comment yet
                              </div>
                            )}
                          </div>
                        </div>
                        {selectedTicket?.requestStatus && (
                          <div className="mt-3">
                            <h6>Status Details:</h6>
                            <div className="alert alert-secondary">
                              {selectedTicket.requestStatus}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setIsTicketDetailsModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="recommendation-modal-close" onClick={() => setIsRecommendationModal(false)}>
              &times;
            </button>
            
            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              {/* GUIDANCE TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  BrandSek continuously monitors social media platforms to detect fake, impersonating,
                  or malicious profiles abusing the organization's brand, executives, or services.
                  These profiles are commonly used for phishing, fraud, misinformation, and reputation damage.
                </div>

                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>What Is Social Media Profile Impersonation</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Social media impersonation involves unauthorized accounts that mimic official brand pages,
                      employees, or executives. Attackers use these profiles to deceive customers,
                      partners, or employees into sharing credentials, making payments, or trusting false information.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Platforms Covered</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Facebook (pages, profiles, ads, Messenger)</li>
                      <li>Instagram (profiles, reels, stories, sponsored content)</li>
                      <li>Twitter / X (handles, replies, DMs, spaces)</li>
                      <li>LinkedIn (fake company pages, employee impersonation, job scams)</li>
                      <li>Telegram (channels, groups, bots, invite-only communities)</li>
                      <li>WhatsApp (business impersonation, scam broadcasts, support fraud)</li>
                      <li>Discord (private servers, crypto scam channels, fake support)</li>
                      <li>YouTube (fake brand channels, scam livestreams, comment phishing)</li>
                      <li>TikTok (impersonation accounts, giveaway scams, deepfake videos)</li>
                      <li>Reddit (brand abuse, fake support threads, data leakage posts)</li>
                      <li>Snapchat (impersonation, direct-message fraud)</li>
                      <li>Quora & Community Forums (misinformation, brand abuse answers)</li>
                      <li>Regional & Niche Platforms (ShareChat, Koo, Weibo, VK, Line)</li>
                      <li>Emerging & Shadow Platforms (invite-only social apps, forks, clones)</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Common Abuse Patterns</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Fake customer support or grievance redressal accounts</li>
                      <li>Impersonation of executives or senior leadership</li>
                      <li>Phishing links shared via posts or direct messages</li>
                      <li>Fraudulent promotions, giveaways, or refund scams</li>
                      <li>Disinformation campaigns impacting brand reputation</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Risk & Business Impact</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Fake social media profiles can lead to direct financial fraud, customer trust erosion,
                      regulatory complaints, and public relations crises. Early detection and rapid takedown
                      are critical to limit exposure and prevent large-scale abuse.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Regulatory & Governance Alignment</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Monitoring and responding to impersonation supports ISO 27001 brand protection controls,
                      CERT-In cyber incident response guidance, and platform-specific abuse reporting requirements.
                    </p>
                  </div>
                </details>
              </div>

              {/* CHECKLIST TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Impersonation Validation</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Confirm profile is not officially owned or authorized</li>
                      <li>Validate brand name, logo, or executive misuse</li>
                      <li>Capture profile URL, screenshots, and metadata</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.7 · Brand Protection</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Threat & Abuse Assessment</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Identify phishing, scam, or fraud indicators</li>
                      <li>Check for malicious links or contact details</li>
                      <li>Assess executive or customer targeting risk</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.8.16 · Threat Monitoring</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Takedown & Platform Escalation</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Submit platform-specific takedown request</li>
                      <li>Provide evidence and brand authorization</li>
                      <li>Track takedown status and platform response</li>
                    </ul>
                    <div className="compliance-tag">Platform Abuse Policies · CERT-In</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Post-Incident Monitoring</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Monitor for re-creation or mirror profiles</li>
                      <li>Inform PR or communications teams if required</li>
                      <li>Retain evidence for audit and legal reference</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.25 · Continuous Monitoring</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SocialMediaProfile;
